import React, { useEffect, useMemo, useState, useCallback } from "react";
// ✨ NOVO: Adiciona imports do react-router-dom
import { useParams, useNavigate } from "react-router-dom"; 
import axiosInstance, {API_BASE_URL} from "../services/axiosInstance";
import styles from "./Styles.module.css";
import { FaFileDownload, FaEye } from "react-icons/fa";
import { LiaUserFriendsSolid } from "react-icons/lia";
import { toast } from "react-toastify";
import ModalEditarPauta from "../components/Modals/ModalEditarPauta";
import ModalVincularComissoes from "../components/Modals/ModalVincularComissoes";
import HistoricoStatusTabela from "../components/HistoricoStatusTabela";
import { Clipboard, ClipboardPen, SquareX, Link as LinkIcon, FileType } from "lucide-react";
import FileViewer from "../components/FileViewer";
import TransicaoComLoading from "../components/TransicaoComLoading";
import DockMenu from "../components/DockMenu";
// import UserInfo from "../components/UserInfo"; 

/* BUBBLE */
const Bubble = ({ title, meta, side = "left", children }) => (
  <div className={`${styles.bubbleWrap} ${side === "right" ? styles.bubbleWrapRight : ""}`}>
    <div className={styles.bubble}>
      {title && <div className={styles.bubbleTitle}>{title}</div>}
      <div>{children}</div>
      {meta && <div className={styles.bubbleMeta}>{meta}</div>}
    </div>
  </div>
);

/* HELPERS */
const obterAutoresFormatados = (autores) => {
  if (!autores) return "";
  if (Array.isArray(autores) && autores.length) {
    const nomes = autores
      .map((a) => a?.usuario?.alias || a?.usuario?.nome || a?.nomeManual || a?.nome || (typeof a === "string" ? a : ""))
      .filter(Boolean);
    return nomes.join(", ");
  }
  if (typeof autores === "object" && autores !== null) {
    return autores.alias || autores.nome || autores.nomeManual || "";
  }
  if (typeof autores === "string") return autores;
  return "";
};

const getFavoravel = (anexo) => {
  if (typeof anexo?.favoravel === "boolean") return anexo.favoravel;
  if (anexo?.resultado_parecer === "FAVORAVEL") return true;
  if (anexo?.resultado_parecer === "DESFAVORAVEL") return false;
  if (typeof anexo?.parecer_flag === "number") return !!anexo.parecer_flag;
  return null;
};

const badgeFavoravel = (fav) => (
  <span
    style={{
      marginLeft: 8,
      padding: "2px 8px",
      borderRadius: 999,
      fontSize: 12,
      background: fav === true ? "#e6ffed" : fav === false ? "#ffecec" : "#f1f1f1",
      color: fav === true ? "#007a2f" : fav === false ? "#9b1c1c" : "#555",
     // border: "1px solid " + (fav === true ? "#b2f0c0" : fav === false ? "#ffd0d0" : "#ddd"),
      whiteSpace: "nowrap",
    }}
    data-tooltip-id="tooltip-default"
    data-tooltip-content="Resultado do parecer"
  >
    {fav === true ? "Favorável" : fav === false ? "Desfavorável" : "Sem resultado"}
  </span>
);

const extrairConteudoTexto = (obj) =>
  obj?.conteudoTexto ||
  obj?.conteudoHtml ||
  obj?.textoHtml ||
  obj?.parecerHtml ||
  obj?.conteudo ||
  obj?.texto ||
  obj?.parecer ||
  obj?.descricao ||
  "";

const normalizar = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const cargoEPermiteEdicao = (perfilRaw) => {
  const p = perfilRaw?.usuario ? perfilRaw.usuario : (perfilRaw || {});
  const tipo = String(p.tipo || p.role || p.perfil || "").toLowerCase();
  const cargo = String(p.cargo || p.funcao || "").toLowerCase();
  const ehGestor =
    ["admin", "administrador", "root", "servidor", "server", "gestor", "secretaria"].some(t =>
      tipo.includes(t)
    );
  if (ehGestor) return true;
  const isPresidente = cargo.includes("presidente") && !cargo.includes("vice");
  return isPresidente;
};

const normalizarPerfil = (src) => {
  if (!src) return null;
  const u = src.usuario ? src.usuario : src;
  return {
    id: u.id ?? src.id ?? null,
    tipo: u.tipo ?? u.role ?? u.perfil ?? src.tipo ?? src.role ?? null,
    cargo: u.cargo ?? u.funcao ?? src.cargo ?? src.funcao ?? null,
  };
};

const fetchPerfilAtual = async () => {
  try {
    const keys = ["perfil", "usuario", "user"];
    for (const k of keys) {
      const raw = localStorage.getItem(k);
      if (raw) {
        const p = JSON.parse(raw);
        const n = normalizarPerfil(p);
        if (n?.id || n?.tipo || n?.cargo) return n;
      }
    }
    const tipoLS = localStorage.getItem("tipo") || localStorage.getItem("role") || null;
    const cargoLS = localStorage.getItem("cargo") || localStorage.getItem("funcao") || null;
    if (tipoLS || cargoLS) return { id: null, tipo: tipoLS, cargo: cargoLS };
  } catch {}
  const rotas = ["/usuarios/perfil", "/usuarios/me", "/auth/me", "/perfil"];
  for (const r of rotas) {
    try {
      const { data } = await axiosInstance.get(r);
      const n = normalizarPerfil(data);
      if (n?.id || n?.tipo || n?.cargo) return n;
    } catch {}
  }
  return null;
};

function stringUpper(v) {
  if (v === true) return "APROVADO";
  if (v === false) return "REJEITADO";
  if (typeof v === "string") return v.toUpperCase();
  return "—";
}

const nomeOuAlias = (u) => u?.alias || u?.nome || u?.displayName || u?.email || `Usuário #${u?.id || "?"}`;
const escolhaLabel = (v) => (v?.escolha ? String(v.escolha) : "Faltou");
const isFaltou = (v) => !v || !v.escolha || String(v.escolha).toLowerCase() === "faltou";
const labelTipo = (tipoMateriaNome, relacaoTipo) => {
  const t = (tipoMateriaNome || "").trim();
  if (t) return t;
  const r = String(relacaoTipo || "").toUpperCase();
  if (r === "EMENDA") return "Emenda";
  if (r === "VETO") return "Veto";
  if (r === "NORMA") return "Norma";
  return "Relacionado";
};
const unique = (arr) => Array.from(new Set(arr));

// NOVO HELPER: Cores dos votos
const getEstiloVoto = (escolha) => {
  const e = String(escolha || "").toLowerCase();
  // SIM
  if (e.startsWith("sim") || e.includes("aprov")) {
    return { backgroundColor: "#1ca882", color: "#FFF", border: "1px solid #148062" };
  }
  // NÃO
  if (e.startsWith("nã") || e.startsWith("nao") || e.includes("rejeit")) {
    return { backgroundColor: "#f44336", color: "#FFF", border: "1px solid #d32f2f" };
  }
  // ABSTENÇÃO
  if (e.startsWith("abst")) {
    return { backgroundColor: "#ffa500", color: "#FFF", border: "1px solid #e69500" };
  }
  // FALTOU / OUTROS
  return { backgroundColor: "#f1f1f1", color: "#777", border: "1px solid #ddd" };
};

/* COMPONENTE */
const Materia = () => {
  const { id: pautaId } = useParams();
  const navigate = useNavigate();

  const [pauta, setPauta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tiposMateria, setTiposMateria] = useState([]);
  const [podeEditar, setPodeEditar] = useState(false);
  const [pautaParaComissao, setPautaParaComissao] = useState(null);
  const [modalEditarPauta, setModalEditarPauta] = useState(null);
  const [visualizarAnexo, setVisualizarAnexo] = useState(null);
  const [historico, setHistorico] = useState(null);
  const [pautaOrigem, setPautaOrigem] = useState(null);
  const [pautaRelacionada, setPautaRelacionada] = useState(null);
  const [vetosContraEsta, setVetosContraEsta] = useState([]);
  const [normaGerada, setNormaGerada] = useState(null);
  const [activeTab, setActiveTab] = useState("Ementa");
  const [activeComissaoId, setActiveComissaoId] = useState(null);
  const [vereadoresAtivos, setVereadoresAtivos] = useState([]);
  const [relacionadosConteudo, setRelacionadosConteudo] = useState({});
  
  const onClose = useCallback(() => {
    navigate(-1); 
  }, [navigate]);

  useEffect(() => {
    axiosInstance.get("/tipos-materia").then((res) => setTiposMateria(res.data)).catch(() => {});
    axiosInstance
      .get("/usuarios/vereadores")
      .then(({ data }) => {
        const arr = Array.isArray(data) ? data : [];
        const ativos = arr.filter((u) => u?.ativo !== false && String(u?.status || "").toLowerCase() !== "inativo");
        setVereadoresAtivos(ativos);
      })
      .catch(() => setVereadoresAtivos([]));
  }, []);

  const carregarHistorico = useCallback(async (id) => {
    try {
      const { data } = await axiosInstance.get(`/pautas/${id}/historico`);
      setHistorico(data || null);
      setVetosContraEsta(
        Array.isArray(data?.eventos)
          ? data.eventos
              .filter((ev) => ev?.tipo === "VETO" && ev?.meta?.origem === "contra-esta")
              .map((ev) => ev.meta?.vetoId)
              .filter(Boolean)
          : []
      );
      if (data?.norma) setNormaGerada(data.norma);
      const origemId = data?.norma?.pautaOrigemId;
      if (origemId) {
        try {
          const { data: origem } = await axiosInstance.get(`/pautas/${origemId}`);
          setPautaOrigem(origem);
        } catch {}
      }
    } catch {
      setHistorico(null);
    }
  }, []);

  const fetchRelacionado = useCallback(async (idRelacionado) => {
    try {
      const { data } = await axiosInstance.get(`/pautas/${idRelacionado}`);
      setRelacionadosConteudo((prev) => ({
        ...prev,
        [idRelacionado]: {
          carregado: true,
          titulo: data?.titulo ?? "",
          numero: data?.numero ?? null,
          tipoMateria: data?.tipoMateria?.nome ?? null,
          minuta: data?.minuta ?? null,
          texto_completo: data?.texto_completo ?? null,
          autores: data?.autores ?? null,
          dataCriacao: data?.criacao ?? null,
        },
      }));
    } catch {
      setRelacionadosConteudo((prev) => ({
        ...prev,
        [idRelacionado]: { carregado: true, titulo: "", numero: null, tipoMateria: null, minuta: null, texto_completo: null },
      }));
    }
  }, []);

  const carregarPauta = useCallback(async () => {
    if (!pautaId) return; 
    setLoading(true);
    try {
      const [{ data: pautaData }, perfilAtual] = await Promise.all([axiosInstance.get(`/pautas/${pautaId}`), fetchPerfilAtual()]);
      setPauta(pautaData);
      const temPoderDeEdicaoGeral = cargoEPermiteEdicao(perfilAtual || {});
      setPodeEditar(temPoderDeEdicaoGeral);
      if (pautaData?.pautaVetada) setPautaRelacionada(pautaData.pautaVetada);
      if (!pautaData?.pautaVetada && pautaData?.pautaRelacionadoId) {
        try {
          const { data: rel } = await axiosInstance.get(`/pautas/${pautaData.pautaRelacionadoId}`);
          setPautaRelacionada(rel);
        } catch {}
      }
      await carregarHistorico(pautaId);
      const pai = pautaData?.relacionados?.pai ? [pautaData.relacionados.pai] : [];
      const filhos = Array.isArray(pautaData?.relacionados?.filhos) ? pautaData.relacionados.filhos : [];
      const idsParaCarregar = unique([...pai, ...filhos].map((r) => r?.id).filter(Boolean));
      if (idsParaCarregar.length) {
        await Promise.all(idsParaCarregar.map((rid) => fetchRelacionado(rid)));
      }
    } catch {
      toast.error("Erro ao carregar dados.");
    } finally {
      setLoading(false);
    }
  }, [pautaId, carregarHistorico, fetchRelacionado]);

  useEffect(() => {
    carregarPauta();
  }, [carregarPauta]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const tipoObj = useMemo(() => {
    return pauta?.tipoMateria || tiposMateria.find((t) => t.id === pauta?.tipoMateriaId) || null;
  }, [pauta?.tipoMateria, pauta?.tipoMateriaId, tiposMateria]);

  const tipoNome = (tipoObj?.nome || "").toLowerCase();
  const tipoLabel = tipoObj?.abreviacao?.trim() ? tipoObj.abreviacao : tipoObj?.nome;
  const isVeto = tipoNome.includes("veto");
  const isNorma = tipoNome.includes("norma") || tipoNome.includes("lei");
  
  const pareceresTodos = useMemo(() => {
    const pareceresDeAnexos = (pauta?.anexos || [])
      .filter((a) => a?.tipo === "Parecer da Comissão")
      .map((a) => ({
        id: a.id,
        comissao: a.comissao || null,
        comissaoId: a.comissao?.id || null,
        titulo: a.descricao || (a?.comissao?.sigla ? `Parecer ${String(a.comissao.sigla).toUpperCase()}` : "Parecer"),
        conteudoHtml: extrairConteudoTexto(a),
        autores: a.autores || a.relator || null,
        dataCriacao: a.data || a.data_criacao || a.createdAt || null,
        nomeArquivo: a.nomeArquivo || null,
        favoravel: getFavoravel(a),
        _origem: "anexo",
      }));

    const pareceresDeRelacionados = (pauta?.relacionados?.filhos || [])
      .filter((f) => f.tipo === 'PARECER' && f.comissao?.id)
      .map((f) => {
          const conteudo = relacionadosConteudo[f.id] || {};
          return {
              id: f.id,
              comissao: f.comissao,
              comissaoId: f.comissao.id,
              titulo: f.titulo || `Parecer ${f.comissao.nome}`,
              conteudoHtml: conteudo.texto_completo || conteudo.minuta || "Carregando conteúdo...",
              autores: conteudo.autores,
              dataCriacao: conteudo.dataCriacao,
              nomeArquivo: null,
              favoravel: null,
              _origem: "pauta_relacionada",
          }
      });

    return [...pareceresDeAnexos, ...pareceresDeRelacionados];
  }, [pauta?.anexos, pauta?.relacionados?.filhos, relacionadosConteudo]);


  const pareceresPorComissao = useMemo(() => {
    return pareceresTodos.reduce((acc, parecer) => {
      const comissaoId = parecer.comissaoId;
      if (comissaoId) {
        if (!acc[comissaoId]) acc[comissaoId] = [];
        acc[comissaoId].push(parecer);
      }
      return acc;
    }, {});
  }, [pareceresTodos]);

  const groupedAnexos = useMemo(() => {
    if (!pauta?.anexos) return {};
    return pauta.anexos.reduce((acc, anexo) => {
      const tipo = anexo.tipo || 'Outros';
      if (!acc[tipo]) {
        acc[tipo] = [];
      }
      acc[tipo].push(anexo);
      return acc;
    }, {});
  }, [pauta?.anexos]);

  const relacionadosTodos = useMemo(() => {
    const pai = pauta?.relacionados?.pai ? [{ ...pauta.relacionados.pai, origem: "pai" }] : [];
    const filhos = Array.isArray(pauta?.relacionados?.filhos) ? pauta.relacionados.filhos.map((f) => ({ ...f, origem: "filho" })) : [];
    return [...pai, ...filhos];
  }, [pauta]);

  const baseTabs = useMemo(() => {
    const tabs = ["Ementa", "Íntegra"];
    if (pauta?.comissoesRelacionadas?.length > 0) {
      tabs.push("Comissões");
    }
    const temVinculos = !!pautaRelacionada || !!pautaOrigem || (vetosContraEsta?.length > 0) || !!normaGerada || !!pauta?.pautaVetada || !!pauta?.pautaRelacionadoId;
   // if (temVinculos) tabs.push("Vínculos");
    tabs.push("Tramitação", "Votações", "Anexos");
    return tabs;
  }, [
    pauta?.comissoesRelacionadas,
    isNorma,
    historico?.norma,
    pautaRelacionada,
    pautaOrigem,
    vetosContraEsta,
    normaGerada,
    pauta
  ]);
  
  const relacionadosTabs = useMemo(() => {
    const labels = relacionadosTodos
      .map((r) => labelTipo(r?.tipoMateria, r?.tipo))
      .filter((l) => l && !l.toLowerCase().includes("parecer"));

    const seen = new Set();
    const ordered = [];
    labels.forEach((lb) => {
      if (!seen.has(lb)) {
        seen.add(lb);
        ordered.push(lb);
      }
    });
    return ordered;
  }, [relacionadosTodos]);

  const dynamicTabs = useMemo(() => {
    const idx = baseTabs.indexOf("Íntegra");
    if (idx < 0 || relacionadosTabs.length === 0) return baseTabs;
    const before = baseTabs.slice(0, idx + 1);
    const after = baseTabs.slice(idx + 1);
    return [...before, ...relacionadosTabs, ...after];
  }, [baseTabs, relacionadosTabs]);

  useEffect(() => {
    if (!dynamicTabs.includes(activeTab)) setActiveTab(dynamicTabs[0]);
  }, [dynamicTabs, activeTab]);

  useEffect(() => {
    if (activeTab === 'Comissões') {
      const primeiraComissaoId = pauta?.comissoesRelacionadas?.[0]?.comissao?.id;
      if (primeiraComissaoId) {
        setActiveComissaoId(primeiraComissaoId);
      }
    }
  }, [activeTab, pauta?.comissoesRelacionadas]);
  
  if (loading) {
    return (
      <div className={styles.modalOverlay}> 
        <div className={styles.modal}>
          <TransicaoComLoading />
        </div>
      </div>
    );
  }
  
  if (!pautaId || !pauta) return null;

  const formatarDataLonga = (iso) => iso ? new Date(iso).toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long", year: "numeric" }) : "";
  const openPautaEmNovaAba = (id) => window.open(`/materia/${id}`, "_blank", "noopener,noreferrer");

  const renderAbaRelacionado = (label) => {
    const items = relacionadosTodos.filter((r) => labelTipo(r?.tipoMateria, r?.tipo) === label);
    if (!items.length) return <Bubble><div className={styles.textoFormatado}>Nenhuma matéria vinculada deste tipo.</div></Bubble>;
    return (
      <>
        {items.map((rel) => {
          const info = relacionadosConteudo[rel.id] || {};
          const temAlgo = (info?.minuta && String(info.minuta).trim()) || (info?.texto_completo && String(info.texto_completo).trim());
          return (
            <Bubble key={rel.id} title={<>{(info?.tipoMateria || label) + (info?.numero ? ` nº ${info.numero}` : "")}</>} meta={<button className={styles.btnCast} onClick={() => openPautaEmNovaAba(rel.id)}><LinkIcon size={16} /> Abrir matéria completa</button>}>
              {!temAlgo ? <div className={styles.textoFormatado} style={{ opacity: 0.8 }}>Conteúdo não disponível.</div> : (
                <>
                  {info?.minuta && <div style={{ marginBottom: 16 }}><div className={styles.bubbleTitle} style={{ marginBottom: 8 }}>Minuta</div><div className={styles.textoFormatado} dangerouslySetInnerHTML={{ __html: info.minuta }} /></div>}
                  {info?.texto_completo && <div><div className={styles.bubbleTitle} style={{ marginBottom: 8 }}>Íntegra</div><div className={styles.textoFormatado} dangerouslySetInnerHTML={{ __html: info.texto_completo }} /></div>}
                </>
              )}
            </Bubble>
          );
        })}
      </>
    );
  };
  
  const cargoUsuario = {}; // Placeholder
  const executarComTransicao = () => {}; // Placeholder
  const UserInfo = () => <div>Usuário</div>; // Placeholder

  return (
    <div className={styles.content}>
      <header className={styles.dashboardHeader}>
        <h3 style={{flexDirection: "column", alignItems: "flex-start"}}>
          <strong style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
            <Clipboard size={25} /> {tipoLabel ?? "—"} nº {pauta.numero}
          </strong>
          {(pauta.autores?.length || pauta.autor) && (
            <small style={{ fontSize: "0.65rem", opacity: 0.8, color: "#555", marginLeft: 25 }}>
              {obterAutoresFormatados(pauta.autores ?? pauta.autor)}, {pauta.criacao ? `Protocolada em ${new Date(pauta.criacao).toLocaleDateString("pt-BR")}` : null}
            </small>
          )}
        </h3>
        <div style={{ display: "flex", alignItems: 'center' }}>
          <div className={styles.usuarioLogado}>
            <img src={`${API_BASE_URL}/images/logo_camara.png`} alt="Logo da Câmara" />
            <UserInfo />
          </div>
        </div>
        
      </header>

        <div className={styles.btnAcoesTransmissao} style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8, color: "#128bf4" }}>
          {podeEditar && (
            <button style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} className={styles.btnCast} onClick={() => setPautaParaComissao(pauta)}>
              <strong style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}><LiaUserFriendsSolid size={20} /> VINCULAR COMISSÃO</strong>
              <small style={{ fontSize: "0.65rem", opacity: 0.8, color: "#555" }}> Altera para fase de Comissões</small>
            </button>
          )}
          {podeEditar && (
            <button style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} onClick={() => setModalEditarPauta(pauta.id)} className={styles.btnPlay} title="Editar matéria">
              <strong style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}><ClipboardPen size={20} /> Editar matéria</strong>
              <small style={{ fontSize: "0.65rem", opacity: 0.8, color: "#555" }}> Altera dados da matéria</small>
            </button>
          )}
        </div>

        <div className={styles.tabsBar} role="tablist" aria-label="Seções da matéria">
          {dynamicTabs.map((t) => (
            <button key={t} role="tab" aria-selected={activeTab === t} className={`${styles.tabBtn} ${activeTab === t ? styles.tabActive : ""}`} onClick={() => setActiveTab(t)}>
              {t}
            </button>
          ))}
        </div>

        <div className={`${styles.modalContentScrollable} ${styles.modalFlow}`}>
          {activeTab === "Ementa" && (pauta.minuta ? <Bubble><div className={styles.textoFormatado} dangerouslySetInnerHTML={{ __html: pauta.minuta }} /></Bubble> : <Bubble><div className={styles.textoFormatado}>Sem ementa cadastrada.</div></Bubble>)}

          {activeTab === "Íntegra" && (pauta.texto_completo ? <Bubble><div className={`${styles.tiptap} tiptap`} dangerouslySetInnerHTML={{ __html: pauta.texto_completo }} /></Bubble> : <Bubble><div className={styles.textoFormatado}>Sem texto completo cadastrado.</div></Bubble>)}

          {activeTab === "Comissões" && (
            <>
              <div className={styles.tabsBar} style={{ padding: 4, borderRadius: 8, marginBottom: 16 }}>
                {(pauta.comissoesRelacionadas || []).map(rel => (
                  <button
                    key={rel.comissao.id}
                    className={`${styles.tabBtn} ${activeComissaoId === rel.comissao.id ? styles.tabActive : ""}`}
                    onClick={() => setActiveComissaoId(rel.comissao.id)}
                  >
                    {rel.comissao.sigla || rel.comissao.nome}
                  </button>
                ))}
              </div>
              
              {activeComissaoId && (() => {
                const pareceresDaComissao = pareceresPorComissao[activeComissaoId] || [];
                if (pareceresDaComissao.length === 0) {
                  return <Bubble><div className={styles.textoFormatado}>Nenhum parecer desta comissão encontrado para esta matéria.</div></Bubble>;
                }
                return pareceresDaComissao.map((p, idx) => (
                  <Bubble
                    key={p.id || idx}
                    title={<>
                      {p.titulo}
                      {typeof p.favoravel === "boolean" && badgeFavoravel(p.favoravel)}
                    </>}
                    meta={[
                      p.dataCriacao ? `Data: ${new Date(p.dataCriacao).toLocaleDateString("pt-BR")}` : null,
                      p.autores ? `Relatoria: ${obterAutoresFormatados(p.autores)}` : null,
                      p._origem === "anexo" && p.nomeArquivo ? `Arquivo: ${p.nomeArquivo}` : null,
                      p._origem === "pauta_relacionada" ? <button key={`btn-${p.id}`} className={styles.btnCast} style={{padding:0, fontSize: 'inherit'}} onClick={() => openPautaEmNovaAba(p.id)}><LinkIcon size={14} /> Ver matéria do parecer</button> : null,
                    ].filter(Boolean).reduce((acc, item, i) => (
                        <React.Fragment key={i}>
                            {acc}
                            {i > 0 && <span style={{margin: '0 8px'}}>•</span>}
                            {item}
                        </React.Fragment>
                    ), null)}
                  >
                    <div className={styles.textoFormatado} dangerouslySetInnerHTML={{ __html: p.conteudoHtml }} />
                  </Bubble>
                ));
              })()}
            </>
          )}

          {relacionadosTabs.includes(activeTab) && renderAbaRelacionado(activeTab)}
          
          {activeTab === "Vínculos" && (
            <>
              {isVeto && pautaRelacionada && (
                <Bubble>
                  <div className={styles.metaList}>
                    <p>{pautaRelacionada?.titulo || "—"}</p>
                    {!!pautaRelacionada?.id && (
                      <button className={styles.btnCast} onClick={() => openPautaEmNovaAba(pautaRelacionada.id)}>
                        <LinkIcon size={16} /> Abrir matéria vetada
                      </button>
                    )}
                  </div>
                </Bubble>
              )}
              {Array.isArray(vetosContraEsta) && vetosContraEsta.length > 0 && (
                <Bubble meta={`${vetosContraEsta.length} registro(s)`}>
                  <ul className={styles.listaBlocoMaterias}>
                    {vetosContraEsta.map((vId) => (
                      <li key={vId} className={styles.metaItemPlain} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                        <span>Veto #{vId}</span>
                        <button className={styles.btnCast} onClick={() => openPautaEmNovaAba(vId)}>
                          <LinkIcon size={16} /> Abrir veto
                        </button>
                      </li>
                    ))}
                  </ul>
                </Bubble>
              )}
              {isNorma && (pautaOrigem || pautaRelacionada) && (
                <Bubble>
                  <div className={styles.metaList}>
                    <p>
                      {(pautaOrigem?.tipoMateria?.nome || pautaRelacionada?.tipoMateria?.nome || "Matéria")} nº {pautaOrigem?.numero || pautaRelacionada?.numero || "—"} — {pautaOrigem?.titulo || pautaRelacionada?.titulo || "—"}
                    </p>
                    {(pautaOrigem?.id || pautaRelacionada?.id) && (
                      <button className={styles.btnCast} onClick={() => openPautaEmNovaAba(pautaOrigem?.id || pautaRelacionada?.id)}>
                        <LinkIcon size={16} /> Abrir matéria de origem
                      </button>
                    )}
                  </div>
                </Bubble>
              )}
              {!isVeto && !isNorma && !pautaRelacionada && !pautaOrigem && (!vetosContraEsta?.length) && !normaGerada && (
                <Bubble>
                  <div className={styles.textoFormatado}>Nenhum vínculo encontrado.</div>
                </Bubble>
              )}
            </>
          )}

          {activeTab === "Tramitação" && (
            <Bubble>
              <HistoricoStatusTabela pautaId={pautaId} tipoMateriaId={pauta?.tipoMateriaId} />
            </Bubble>
          )}

          {activeTab === "Votações" && (
            <>
              {Array.isArray(pauta.votacoes) && pauta.votacoes.length ? (
                <Bubble meta={`${pauta.votacoes.length} registro(s)`}>
                  <div className={styles.votacoesStack}>
                    {pauta.votacoes.map((votacao, idx) => {
                      const votos = Array.isArray(votacao.votos) ? votacao.votos : [];
                      const votosById = new Map();
                      votos.forEach(voto => {
                        if (voto && voto.usuario && typeof voto.usuario.id === 'number') {
                          votosById.set(voto.usuario.id, voto);
                        }
                      });
                      let linhas = (vereadoresAtivos || []).map((u) => {
                        const voto = votosById.get(Number(u.id));
                        return {
                          id: u.id,
                          nome: nomeOuAlias(u),
                          escolha: escolhaLabel(voto),
                          faltou: isFaltou(voto),
                        };
                      });
                      linhas = linhas.sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
                      const tot = linhas.reduce(
                        (acc, l) => {
                          const e = String(l.escolha || "").toLowerCase();
                          if (l.faltou) {
                            acc.faltou++;
                          } else if (e.startsWith("sim")) {
                            acc.sim++;
                          } else if (e.startsWith("não") || e.startsWith("nao")) {
                            acc.nao++;
                          } else {
                            acc.abstencao++;
                          }
                          return acc;
                        },
                        { sim: 0, nao: 0, abstencao: 0, faltou: 0 }
                      );
                      const tituloLinha = `${stringUpper(votacao.aprovado)} por maioria ${votacao.tipoVotacao} (${votacao.turno})` + (votacao.votacao ? `, ${formatarDataLonga(votacao.votacao)}` : "");
                      return (
                        <div key={idx} className={styles.votacaoCard}>
                          <div className={styles.textoFormatado} style={{ marginBottom: 8, fontSize: "0.75rem" }}>{tituloLinha}</div>
                          
                          {/* Resumo de totais com cores */}
                          <ul className={styles.listaBlocoMaterias} style={{marginBottom: 10, paddingBottom: 10, borderBottom: '1px dashed #eee'}}>
                            <li style={{color: '#1ca882'}}><strong>Sim:</strong> {tot.sim}</li>
                            <li style={{color: '#f44336'}}><strong>Não:</strong> {tot.nao}</li>
                            <li style={{color: '#ffa500'}}><strong>Abstenção:</strong> {tot.abstencao}</li>
                            <li style={{color: '#777'}}><strong>Faltou:</strong> {tot.faltou}</li>
                          </ul>

                          {/* Lista de Votos com Badges */}
                          <ul className={styles.listaBlocoMaterias}>
                            {linhas.map((l) => {
                              const estilo = getEstiloVoto(l.escolha);
                              const isFaltouStyle = l.faltou ? { opacity: 0.6 } : {};

                              return (
                                <li key={l.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", ...isFaltouStyle }} title={l.faltou ? "Vereador não registrou voto" : ""}>
                                  <strong className={styles.votoNome} style={{fontSize: '0.9rem'}}>{l.nome}</strong>
                                  <span style={{
                                      ...estilo,
                                      padding: "2px 10px",
                                      borderRadius: "12px",
                                      fontSize: "0.75rem",
                                      fontWeight: "600",
                                      minWidth: "60px",
                                      textAlign: "center",
                                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
                                  }}>
                                    {l.escolha}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                </Bubble>
              ) : (
                <Bubble>
                  <div className={styles.textoFormatado}>Nenhuma votação cadastrada.</div>
                </Bubble>
              )}
            </>
          )}

          {activeTab === "Anexos" && Object.keys(groupedAnexos).length > 0 && (
            <Bubble>
              <div className={styles.anexosGrid}>
                {Object.entries(groupedAnexos).map(([grupo, lista]) =>
                  lista.length ? (
                    <div key={grupo} className={styles.anexoCard}>
                      <h4 className={styles.anexoTitulo}>{grupo}</h4>
                      <ul className={styles.listaBlocoMaterias}>
                        {lista.map((anexo, i) => {
                          let nomeExibicao = anexo.descricao || anexo.nomeOriginal || anexo.nomeArquivo || `Anexo #${anexo.id}`;
                          const ext = (anexo.nomeArquivo || "").split(".").pop();
                          const nomeDownload = `${nomeExibicao}.${ext || "pdf"}`;
                          const fav = getFavoravel(anexo);
                          const nomeComissao = anexo?.comissao?.sigla || anexo?.comissao?.nome || null;
                          
                          const urlAnexo = anexo.nomeArquivo ? `${axiosInstance.defaults.baseURL}/uploads/${anexo.nomeArquivo}` : null;

                          return (
                            <li key={anexo.id || i} >
                              <span className={styles.anexoNome}>
                                {nomeExibicao}
                                {grupo === "Parecer da Comissão" ? (
                                  <>
                                    {badgeFavoravel(fav)}
                                    {nomeComissao ? <span style={{ marginLeft: 8, fontSize: 12, color: "#555" }}>{nomeComissao}</span> : null}
                                  </>
                                ) : null}
                              </span>
                              <div className={styles.botoesAcaoBlocos}>
                                <button
                                  style={{ fontSize: "0.75rem" }}
                                  type="button"
                                  onClick={() => setVisualizarAnexo({ ...anexo, nomeExibicao, conteudoTexto: extrairConteudoTexto(anexo) })}
                                  className={styles.btnPlay}
                                  title="Visualizar"
                                >
                                  <FaEye size={16} /> Ver
                                </button>
                                {urlAnexo && ( 
                                  <a
                                    href={urlAnexo}
                                    download={nomeDownload}
                                    className={styles.btnAzul}
                                    onClick={() => toast.info("Baixando, aguarde...")}
                                    title="Baixar"
                                  >
                                    <FaFileDownload size={16} /> Baixar
                                  </a>
                                )}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : null
                )}
              </div>
            </Bubble>
          )}
          {activeTab === "Anexos" && Object.keys(groupedAnexos).length === 0 && (
            <Bubble>
              <div className={styles.textoFormatado}>Nenhum anexo.</div>
            </Bubble>
          )}
        </div>
        <DockMenu cargoUsuario={cargoUsuario} executarComTransicao={executarComTransicao} />

        {modalEditarPauta && (
          <ModalEditarPauta
            pautaId={modalEditarPauta}
            onClose={() => setModalEditarPauta(null)}
            onSave={() => {
              setModalEditarPauta(null);
              carregarPauta();
            }}
          />
        )}
        {visualizarAnexo && (
          <div className={styles.modalOverlay} onClick={() => setVisualizarAnexo(null)}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
              <button className={styles.modalClose} onClick={() => setVisualizarAnexo(null)}><SquareX /></button>
              <h2>{visualizarAnexo.descricao || "Visualizador de Anexo"}</h2>
              {visualizarAnexo.nomeArquivo ? (
                <FileViewer url={`${axiosInstance.defaults.baseURL}/uploads/${visualizarAnexo.nomeArquivo}`} height={600} workerVersion="3.0.279" />
              ) : visualizarAnexo.conteudoTexto ? (
                <div className={styles.modalContentScrollable}>
                  <div className={styles.textoAta} dangerouslySetInnerHTML={{ __html: visualizarAnexo.conteudoTexto }} />
                </div>
              ) : (
                <div className={styles.anexoErro}>Conteúdo não encontrado.</div>
              )}
            </div>
          </div>
        )}
        {pautaParaComissao && (
          <ModalVincularComissoes
            pautaId={pautaParaComissao.id}
            onClose={() => setPautaParaComissao(null)}
            onSaved={() => {
              setPautaParaComissao(null);
              toast.success("Comissões vinculadas e tramitação atualizada.");
              carregarPauta();
            }}
          />
        )}
      </div>
  );
};

export default Materia;